import PropTypes from 'prop-types';
import { useMemo } from 'react';

import { useFetchUserCollection, useUserStore } from '../../core/users/users.hooks';
import { getString } from '../../utils';
import { ensureArray } from '../../utils/arrayUtils';
import { useOrderBy } from '../../utils/hooks';
import SponsorsBlock from './SponsorsBlock';

/**
 * Affiche, à la manière du bloc Sponsors, les users d'une collection qui référencent l'item courant.
 * Relation inverse de WorkshopSponsorsBlock : ici c'est la cible qui porte les ids.
 * Ex: sur un exposant (collection exhibitors), lister les démos (collection demos)
 * dont le champ `exhibitors` contient l'id de l'exposant.
 */
const UsersMatchingBlock = ({ item, field, dataSource, header, orderBy, ...props }) => {
  const { collection } = dataSource;
  useFetchUserCollection(collection);
  const users = useUserStore(collection)?.users;

  const matchingField = field || item.collection;
  const matchingUsers = useMemo(
    () => (users || []).filter((user) => ensureArray(user[matchingField]).includes(item._id)),
    [users, matchingField, item._id],
  );
  const orderedUsers = useOrderBy(matchingUsers, orderBy);
  const ids = useMemo(() => orderedUsers.map((user) => user._id), [orderedUsers]);

  if (ids.length === 0) return null;
  // header={null} permet de masquer complètement le titre
  const blockHeader = header === undefined ? getString(`blocks.${collection}`) || null : header;
  return <SponsorsBlock {...props} header={blockHeader} ids={ids} dataSource={dataSource} />;
};

UsersMatchingBlock.defaultProps = {
  field: undefined,
  header: undefined,
  orderBy: undefined,
};

UsersMatchingBlock.propTypes = {
  item: PropTypes.object.isRequired,
  /** Champ des users de la collection cible contenant les ids. Par défaut, la collection de l'item */
  field: PropTypes.string,
  dataSource: PropTypes.shape({
    kind: PropTypes.string,
    collection: PropTypes.string.isRequired,
  }).isRequired,
  header: PropTypes.string,
  orderBy: PropTypes.arrayOf(
    PropTypes.shape({ field: PropTypes.string, order: PropTypes.oneOf(['asc', 'desc']) }),
  ),
};

export default UsersMatchingBlock;
